import React, { useState } from "react";
import products from "../components/allProductsData";
import "../assets/css/AllProducts.css";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";
import { useNavigate, useLocation } from "react-router-dom"; // ✅ added useLocation

const AllSkinCareProductsPage = () => {
  const navigate = useNavigate();
  const location = useLocation(); // ✅ get current URL

  // get subcategory from query string, default to "All"
  const query = new URLSearchParams(location.search);
  const initialSub = query.get("sub") || "All";

  // Filter only skin care products
  const skinCareProducts = products.filter(
    (item) => item.category === "Skin Care"
  );

  // Extract unique sub-category names from product.description
  const subCategories = [
    "All",
    ...new Set(skinCareProducts.map((item) => item.subCategory || "General")),
  ];

  const [selectedSub, setSelectedSub] = useState(initialSub); // ✅ initialize from query param
  const [currentPage, setCurrentPage] = useState(1);

  const filteredProducts =
    selectedSub === "All"
      ? skinCareProducts
      : skinCareProducts.filter((item) => item.subCategory === selectedSub);

  const itemsPerPage = 6;
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  const paginatedData = filteredProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleFilter = (value) => {
    setSelectedSub(value);
    setCurrentPage(1);
    navigate(`/Skin-Care-Products?sub=${encodeURIComponent(value)}`); // ✅ update URL on click
  };

  return (
    <>
      <BreadcrumbSection
        title="Skin Care Solutions"
        breadcrumbItems={[{ label: "Home", to: "/" }]}
        backgroundImage={BredcrumpImage}
      />

      <div className="allproducts-container">
        <h1 className="page-title">Skin Care Products</h1>

        {/* Sub Category Filter */}
        <div className="category-buttons">
          {subCategories.map((sub) => (
            <button
              key={sub}
              className={`category-btn ${selectedSub === sub ? "active" : ""}`}
              onClick={() => handleFilter(sub)}
            >
              {sub}
            </button>
          ))}
        </div>

        {/* Products */}
        <div className="allproducts-grid">
          {paginatedData.map((product) => (
            <div key={product.id} className="allproducts-card">
              <div className="allproducts-image-wrapper">
                <img src={product.image} alt={product.name} className="allproducts-image" />

                {/* Product Logo */}
                <img src={product.logo} alt="brand" className="allproducts-logo" />

                <div className="allproducts-content">
                  <h5>{product.name}</h5>
                  {/* <p>{product.subCategory || "Skin Care"}</p> */}
                  <div className="product-meta">
                    <span className="product-meta-title">
                      Application Area & Quantity
                    </span>

                    <p className="product-meta-value">
                      {(product.applicationArea || "Skin")}
                      {" · "}
                      {(product.quantity || "—")}
                    </p>
                  </div>

                  <button className="view-button" onClick={() => navigate(product.link)}>View Product</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            Prev
          </button>

          <span>
            {currentPage} / {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
};

export default AllSkinCareProductsPage;
